import { _ as __rest, a as __assign, c as __awaiter, d as __generator } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import React__default from 'react';
import { C as CopyIcon } from '../../CopyIcon-b295a93f.js';
import '../../countries-34fea817.js';
import { B as Button } from '../../index-b7114926.js';
import 'react-router-dom';
import '../../skeleton.module-7c98b8f8.js';
import '../../ThemeProvider-e3ab770b.js';

var styles = {"container":"ClipboardCopy_container_607caf78"};

var ClipboardCopy = React__default.forwardRef(function ClipboardCopy(props, ref) {
    var _a;
    var _this = this;
    var className = props.className; props.iconClassName; var text = props.text, onCopy = props.onCopy, onError = props.onError, onClick = props.onClick, isSkeleton = props.isSkeleton, isDisabled = props.isDisabled, label = props.label, _b = props.noBackground, noBackground = _b === void 0 ? false : _b, dataTestId = props.dataTestId, _c = props.color, color = _c === void 0 ? "action" : _c, otherProps = __rest(props, ["className", "iconClassName", "text", "onCopy", "onError", "onClick", "isSkeleton", "isDisabled", "label", "noBackground", "dataTestId", "color"]);
    var _d = React__default.useState(false), isWriting = _d[0], setIsWriting = _d[1];
    var handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var e_1, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsWriting(true);
                    onClick && onClick(event);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 2:
                    _a.sent();
                    onCopy && onCopy(text);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    err = e_1 instanceof Error ? e_1 : new Error("Error writing text to clipboard");
                    onError && onError(err);
                    return [3 /*break*/, 5];
                case 4:
                    setIsWriting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement("div", __assign({ className: classNames(styles.container, (_a = {}, _a[styles.skeleton] = isSkeleton, _a), className) }, otherProps),
        React__default.createElement(Button, { disabled: isWriting || isDisabled, "aria-busy": isSkeleton, label: label ? label : "Copy to clipboard", variant: noBackground ? "tertiary" : "primary", onClick: handleClick, color: color, isSkeleton: isSkeleton, type: "button", "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : "clipboard-copy", ref: ref },
            React__default.createElement(CopyIcon, null))));
});

export { ClipboardCopy };
